/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { Cbpr2RatesDto, Get7Params } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiRateCbpr2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-rate-cbpr-2-controller
   * @name Get7
   * @request GET:/api/v1/rate-cbpr2
   */
  get = (query: Get7Params, params: RequestParams = {}) =>
    this.http.request<Cbpr2RatesDto, any>({
      path: `/v1/rate-cbpr2`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getPath = '/v1/rate-cbpr2'
  static getMethod = 'GET'
}
